import jstz from "jstz";

export const timezoneName: string = jstz.determine().name();
